import { useTranslation } from 'react-i18next';
import type { ProcessRunListItemType } from '@econtractor/types';
import TableEmptyRow from 'components/others/TableEmptyRow';
import ProcessRunsTableRow from './ProcessRunsTableRow';

interface ProcessRunsTableBodyProps {
    processes: ProcessRunListItemType[];
    onEdit: (process: ProcessRunListItemType) => void;
    onLaunch: (process: ProcessRunListItemType) => void;
    onDelete: (process: ProcessRunListItemType) => void;
    launchingId: number | null;
}

const ProcessRunsTableBody = ({ processes, onEdit, onLaunch, onDelete, launchingId }: ProcessRunsTableBodyProps) => {
    const { t } = useTranslation(['Tasks']);

    return (
        <tbody>
            {!processes.length ? (
                <TableEmptyRow colSpan={6} className="text-muted text-center py-4">
                    {t('processRuns.empty')}
                </TableEmptyRow>
            ) : (
                processes.map((process) => (
                    <ProcessRunsTableRow
                        key={process.ID}
                        process={process}
                        onEdit={onEdit}
                        onLaunch={onLaunch}
                        onDelete={onDelete}
                        launching={launchingId === process.ID}
                    />
                ))
            )}
        </tbody>
    );
};

export default ProcessRunsTableBody;
